<template>
  <div
    class="wspo-layout wspo-lead"
    :class="{ 'wspo-theme-pm': ['pm', 'main-pm'].includes(context) }"
  >
    <div
      class="wspo-main-head"
      v-if="!isError('Access denied') && !isLoading('Initialization')"
    >
      <div class="wspo-main-title">
        Отборные
        <span class="wspo-main-title-accent">{{ typeString }}</span> туры
        <span v-html="countryString"></span>
      </div>
      <div class="wspo-mode-togglers">
        <div
          class="wspo-mode-toggler-max wspo-icon"
          :class="{ 'wspo-active': mode === 'max' }"
          @click="setMode('max')"
        ></div>
        <div
          class="wspo-mode-toggler-min wspo-icon"
          :class="{ 'wspo-active': mode === 'min' }"
          @click="setMode('min')"
        ></div>
      </div>
    </div>

    <Error v-if="isError('Access denied')" code="Access denied" />
    <Loading v-else-if="isLoading('Initialization')" code="Initialization" />
    <Hero v-else />

    <Tour v-if="tour" />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue';
import Error from '@/components/Error.vue';
import Hero from '@/components/Hero.vue';
import Tour from '@/components/Tour.vue';
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'Lead',
  components: {
    Error,
    Loading,
    Hero,
    Tour
  },
  computed: {
    ...mapState(['tour', 'mode']),
    ...mapGetters([
      'isError',
      'isLoading',
      'typeString',
      'countryString',
      'context'
    ])
  },
  methods: {
    ...mapMutations(['setMode'])
  }
};
</script>

<style>
.wspo-main-title-accent {
  background-color: var(--color-bg-dark);
  color: var(--color-alt);
  padding: 0 4px;
}
.wspo-theme-pm .wspo-main-title-accent {
  color: var(--color-text);
}
</style>
<style scoped>
.wspo-lead {
  min-height: 400px;
  justify-content: center;
}
.wspo-main-head {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 18px;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}
.wspo-main-title {
  font-size: 32px;
  text-align: left;
  flex: 1;
}
@media (max-width: 1000px) {
  .wspo-main-title {
    font-size: 24px;
  }
}
.wspo-mode-togglers {
  display: flex;
  align-items: center;
  background-color: var(--color-bg-dark);
  border-radius: 20px;
  padding: 2px 8px;
}
.wspo-mode-toggler-max,
.wspo-mode-toggler-min {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s;
  cursor: pointer;
}
.wspo-mode-togglers .wspo-active:before {
  color: var(--color-main);
  transition: color 0.3s;
}
.wspo-mode-toggler-max:before,
.wspo-mode-toggler-min:before {
  font-size: 22px;
  text-align: center;
  width: 100%;
}
.wspo-mode-toggler-max:before {
  content: '\f039';
}
.wspo-mode-toggler-min:before {
  content: '\f009';
}
</style>
